class ProductFormVariants extends HTMLElement {
  constructor() {
    super();

    this.form = this.closest('form');
    this.sectionId = this.form?.querySelector('input[name="section-id"]')?.value;

    console.log('ProductFormVariants initialized with sectionId:', this.sectionId);
    console.log('Form found:', this.form);

    this.inputs = this.querySelectorAll('input[type=radio]');

    this.inputs.forEach(input => {
      input.addEventListener('change', () => {
        console.log('Radio input change event triggered.');
        this.onVariantChange();
      });
    });
  }

  onVariantChange() {
    console.log('Variant change detected.');

    const variantId = this.getSelectedVariantId();
    console.log('Selected variant ID:', variantId);
    console.log('Section ID:', this.sectionId);

    if (!variantId || !this.sectionId) return;

    const url = `${window.location.pathname}?variant=${variantId}&section_id=${this.sectionId}`;
    console.log('Fetching new section from URL:', url);

    fetch(url)
      .then(res => res.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newSection = doc.querySelector(`#shopify-section-${this.sectionId}`);
        const currentSection = document.querySelector(`#shopify-section-${this.sectionId}`);

        console.log('New section HTML parsed:', newSection);
        console.log('Current section in DOM:', currentSection);

        if (!newSection) console.warn('New section not found in fetched HTML');
        if (!currentSection) console.warn('Current section not found in DOM');

        if (newSection && currentSection) {
          currentSection.replaceWith(newSection);
        }
        window.history.replaceState({}, '', `?variant=${variantId}`);

        const benefitsSection = document.querySelector('.product-benefits');
        const benefitsSectionId = benefitsSection?.dataset.sectionId;

        if (benefitsSection && benefitsSectionId) {
          const benefitsUrl = `${window.location.pathname}?variant=${variantId}&section_id=${benefitsSectionId}`;
          console.log('Fetching benefits section from URL:', benefitsUrl);

          fetch(benefitsUrl)
            .then(res => res.text())
            .then(html => {
              const parser = new DOMParser();
              const doc = parser.parseFromString(html, 'text/html');
              const outerSection = doc.querySelector(`#shopify-section-${benefitsSectionId}`);
              const newBenefitsContent = outerSection?.querySelector('.product-benefits');
              if (newBenefitsContent) {
                benefitsSection.replaceWith(newBenefitsContent);
              } else {
                console.warn('New .product-benefits content not found inside fetched section');
              }
            });
        }
      });
  }

  getSelectedVariantId() {
    const values = {};
    this.inputs.forEach(input => {
      if (input.checked) {
        values[input.name] = input.value;
      }
    });

    const selectedTitle = Object.values(values).join(' / ').trim();

    const variant = Theme.Liquid.product.variants.find(v => v.title === selectedTitle);
    return variant?.id || null;
  }
}

customElements.define('product-form-variants', ProductFormVariants);